// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"bug"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M17 9H7V16C7 18.7614 9.23858 21 12 21C14.7614 21 17 18.7614 17 16V9Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M12 2C9.79086 2 8 3.79086 8 6H16C16 3.79086 14.2091 2 12 2Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M7 13H4M7 13V16C7 18.7614 9.23858 21 12 21C14.7614 21 17 18.7614 17 16V13M7 13V9H17V13M20 13H17M12 9V20M6.55 16.45L4 19V21M17.45 16.45L20 19V21M6.65 9.65L4 7V5M17.35 9.65L20 7V5M8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6H8Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-bug')
export default class BugIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'bug',
    }
  }
}
